/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Grant} from '../models/Grant';

export interface GetAvailableGrants$Request {
    grantName?: string;
}

export interface GetAvailableGrants$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAvailableGrantsRequest = createAction<PayloadData<void, GetAvailableGrants$Request>>('RULE_GRANT__GET_AVAILABLE_GRANTS__REQUEST');
export const getAvailableGrantsSuccess = createAction<PayloadData<Array<Grant>, GetAvailableGrants$Request>>('RULE_GRANT__GET_AVAILABLE_GRANTS__SUCCESS');
export const getAvailableGrantsFailure = createAction<PayloadData<Error, GetAvailableGrants$Request, true>>('RULE_GRANT__GET_AVAILABLE_GRANTS__FAILURE');

export const getAvailableGrantsActions = [
    getAvailableGrantsRequest,
    getAvailableGrantsSuccess,
    getAvailableGrantsFailure
] as const;

/**
 * get available grants for approval requests.
 * @param {string} [meta.grantName] Filter grants by name
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAvailableGrants = (meta: GetAvailableGrants$Request, config?: GetAvailableGrants$Config) => {
    const TRANSPORT_GET_PARAMS = {
        grantName: meta.grantName,
    };
    return {
        CALL_API: {
            types: getAvailableGrantsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/approval/requests/grants/available`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

